import * as angular from "angular";
import * as _ from "lodash";
import {QuickFilterContextService} from "../commons/services/quick-filter-context.service";
import {ServiceAnalysisRequestsService} from "../service-analysis/services/service-analysis-requests.service";
import {DateRangeTimeFiltersService} from "../commons/services/date-range-time-filters.service";
import {ViewFilterSettingsService} from "../commons/services/view-filter-settings.service";
import {CommonsService} from "../commons/services/commons-service.service";
import {GroupModel} from "../groups/models/group.model";
import {ServiceAreaRequests} from "../service-areas/services/service-area-requests.service";
import {SplitService} from "../commons/services/split-service.service";
import {ServiceAreasService} from "../service-areas/services/service-areas-service.service";


angular
  .module('bringoz.admin.lean-planning')
  .config(leanPlanningConfig);

function leanPlanningConfig($stateProvider, moment) {

  $stateProvider

    .state('lean-planning', {
      parent: 'bringoz.site',
      url: '/lean-planning?:from&:to&:areaIds&:considerArea&:considerTimeWindows&:maxDeliveries&:onlyUnRouted&:onlyInStore&:branchId',
      reloadOnSearch: false,
      template: '<lean-planning-view segments="segments" from="from" to="to" consider-area="considerArea" open-process-ids="openProcessIds"' +
        'consider-time-windows="considerTimeWindows" service-area-ids="serviceAreaIds" only-in-store="onlyInStore"' +
        'only-un-routed="onlyUnRouted" max-deliveries="maxDeliveries" branch-id="branchId"></lean-planning-view>',
      controller: function ($scope, triBreadcrumbsService, $stateParams, generatingRoutes, configuration, serviceAreaIds, site) {

        $scope.segments = [];
        $scope.from = $stateParams.from ? parseInt($stateParams.from) : moment().startOf('day').valueOf();
        $scope.to = $stateParams.to ? parseInt($stateParams.to) : moment().endOf('day').valueOf();
        $scope.serviceAreaIds = $stateParams.areaIds || serviceAreaIds;
        $scope.considerArea = $stateParams.considerArea ? _.isEqual($stateParams.considerArea, 'true') : configuration.considerServiceArea;
        $scope.considerTimeWindows = $stateParams.considerTimeWindows ? _.isEqual($stateParams.considerTimeWindows, 'true') : configuration.considerTimeWindows;
        $scope.maxDeliveries = $stateParams.maxDeliveries ? parseInt($stateParams.maxDeliveries) : configuration.numberOfServicePerRoute;
        $scope.onlyUnRouted = $stateParams.onlyUnRouted ? _.isEqual($stateParams.onlyUnRouted, 'true') : configuration.onlyUnRouted;
        $scope.onlyInStore = $stateParams.onlyInStore ? _.isEqual($stateParams.onlyInStore, 'true') : configuration.onlyInStore;
        $scope.branchId = $stateParams.branchId;

        $scope.openProcessIds = _.map(generatingRoutes, function (generatingRoute) {
          return generatingRoute.id;
        });

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Planning"});
        triBreadcrumbsService.addCrumb({name: "Planning"});

      },
      resolve: {
        // analysis: function(DeliveriesRequests, $stateParams, site) {
        //     return DeliveriesRequests.getAnalysis(
        //         moment().startOf('day').valueOf(),
        //         moment().endOf('day').valueOf(),
        //         $stateParams.areaIds || [],
        //         _.isEqual($stateParams.considerArea, 'true'),
        //         _.isEqual($stateParams.considerTimeWindows, 'true'),
        //         _.isEqual($stateParams.onlyInStore, 'true'),
        //         $stateParams.maxDeliveries || 20,
        //         _.isEqual($stateParams.onlyUnRouted, 'true')
        //     )
        // },
        configuration: function (deliveriesRequestsService, site) {
          return deliveriesRequestsService.getAnalysisConfiguration();
        },
        generatingRoutes: function (serviceAnalysisRequestsService: ServiceAnalysisRequestsService, site) {
          return serviceAnalysisRequestsService.getGeneratingRoutes();
        },
        serviceAreaIds: function ($serviceArea, $stateParams, serviceAreaRequests,
                                  $q, serviceAreasService: ServiceAreasService, site, configuration) {
          if ($stateParams.considerArea || configuration.considerServiceArea) {
            if ($stateParams.branchId) {
              return serviceAreaRequests.getAll({branchIds: [$stateParams.branchId]})
                .then((serviceAreas: any[]) => {
                  const areaIds = _.map(serviceAreas, function (area) {
                    return area.areaId;
                  });
                  return $q.all(areaIds)
                })
            } else {
              return serviceAreasService.getAll({})
                .then((serviceAreas: any[]) => {
                  const areaIds = _.map(serviceAreas, function (area) {
                    return area.areaId;
                  });
                  return $q.all(areaIds)
                });
            }
          } else {
            return [];
          }


          // Older Implementation
          // if ($stateParams.branchId) {
          //     return ServiceAreaRequests.getAreasByBranches([$stateParams.branchId])
          //         .then(function(serviceAreas) {
          //             var areaIds = _.map(serviceAreas, function(area) {
          //                 return area.areaId;
          //             });
          //             return $q.all(areaIds)
          //         })
          // } else {
          //     return $serviceArea().$getAll();
          // }


        }
      }
    })
    .state('planning-routes', {
      parent: 'bringoz.site',
      controllerAs: 'vm',
      url: '/planning/routes?:from&:to&:serviceAreaIds&:routeStatuses&:agentIds&:routeIds&:resourceIds&:agentSkills&:branchIds&:groupIds&:agentScheduleIds',
      template: '<planning-routes-test from="vm.from" to="vm.to" route-statuses="vm.routeStatuses" ids="vm.routeIds" service-area-ids="vm.serviceAreaIds" branch-ids="vm.branchIds" ' +
        'agent-ids="vm.agentIds" resource-ids="vm.resourceIds" agent-skills="vm.agentSkills" selected-quick-filter-id="vm.selectedQuickFilterId"' +
        'group-ids="vm.groupIds" groups-branch-ids="vm.groupsBranchIds" date-range-template-type="vm.dateRangeTemplateType" agent-schedule-ids="vm.agentScheduleIds" service-areas-map="vm.serviceAreasMap">' +
        '</planning-routes-test>',
      controller: function ($route, triBreadcrumbsService, commonsService: CommonsService, $stateParams, viewFilterSettingsService: ViewFilterSettingsService, dateRangeTimeFiltersService: DateRangeTimeFiltersService,
                            groups, $state, serviceAreasMap, site) {

        this.serviceAreasMap = serviceAreasMap;
        const quickActiveFilter = viewFilterSettingsService.getActiveQuickFilter($state.current.name);
        this.dateRangeTemplateType = $stateParams.dateRangeTemplateType || quickActiveFilter?.settings.dateRangeTemplateType;

        if ($stateParams.from && $stateParams.to) {
          this.from = parseInt($stateParams.from)
          this.to = parseInt($stateParams.to);
        } else if (this.dateRangeTemplateType) {
          const dateRangeFilter = dateRangeTimeFiltersService.getDateRangeFilterByType(this.dateRangeTemplateType);
          this.from = dateRangeFilter.dateStart;
          this.to = dateRangeFilter.dateEnd;
        }

        this.selectedQuickFilterId = quickActiveFilter?.id;

        this.groupIds = commonsService.parseArrayStateParam($stateParams.groupIds) || quickActiveFilter?.settings.groupIds || [];
        this.groupsBranchIds = [];

        if (groups.length) {
          groups.forEach((g: GroupModel) => {
            if (g.branchIds?.length) {
              this.groupsBranchIds = this.groupsBranchIds.concat(g.branchIds);
            }
          });
        }

        this.branchIds = _.uniq(this.groupsBranchIds.concat(commonsService.parseArrayStateParam($stateParams.branchIds) || quickActiveFilter?.settings.branchIds || viewFilterSettingsService.getBranchIds() || []));
        this.routeIds = commonsService.parseArrayStateParam($stateParams.routeIds);
        this.routeStatuses = commonsService.parseArrayStateParam($stateParams.routeStatuses) || quickActiveFilter?.settings?.routeStatuses;
        this.serviceAreaIds = commonsService.parseArrayStateParam($stateParams.serviceAreaIds) || quickActiveFilter?.settings?.serviceAreaIds || viewFilterSettingsService.getServiceAreaIds() || [];
        this.agentIds = commonsService.parseArrayStateParam($stateParams.agentIds) || quickActiveFilter?.settings?.agentIds;
        this.agentSkills = commonsService.parseArrayStateParam($stateParams.agentSkills) || quickActiveFilter?.settings?.agentSkills;
        this.resourceIds = commonsService.parseArrayStateParam($stateParams.resourceIds) || quickActiveFilter?.settings?.resourceIds;
        this.agentScheduleIds = commonsService.parseArrayStateParam($stateParams.agentScheduleIds) || quickActiveFilter?.settings?.agentScheduleIds;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Routes"});
        triBreadcrumbsService.addCrumb({name: "Planning"});

      },
      resolve: {
        groups: function ($groups, $stateParams, site) {
          return $stateParams.groupIds?.length ? $groups().$asyncValues($stateParams.groupIds) : [];
        },
        serviceAreasMap: function (serviceAreaRequests: ServiceAreaRequests, site) {
          return serviceAreaRequests.getAreaNameMap();
        }
      }
    })

    .state('planning-routes-timeline', {
      parent: 'bringoz.site',
      controllerAs: 'vm',
      url: '/planning/routes-new?:from&:to&:areaIds&:branchIds&:agentIds&:status&:dateRangeTemplateType&:agentSkills',
      template: '<planning-dispatch-routes-view from="vm.from" to="vm.to" service-area-ids="vm.areaIds" ' +
        'branch-ids="vm.branchIds" agent-ids="vm.agentIds" agent-skills="vm.agentSkills" status="vm.status" ' +
        'selected-quick-filter-id="vm.selectedQuickFilterId" date-range-template-type="vm.dateRangeTemplateType"></planning-dispatch-routes-view>',
      controller: function ($route, triBreadcrumbsService, $stateParams, quickFilterContextService: QuickFilterContextService,
                            commonsService: CommonsService, dateRangeTimeFiltersService: DateRangeTimeFiltersService, viewFilterSettingsService: ViewFilterSettingsService, $state, site) {

        const quickActiveFilter = viewFilterSettingsService.getActiveQuickFilter($state.current.name);
        this.selectedQuickFilterId = quickActiveFilter?.id;
        this.dateRangeTemplateType = $stateParams.dateRangeTemplateType || quickActiveFilter?.settings.dateRangeTemplateType;
        this.areaIds = $stateParams.areaIds || quickActiveFilter?.settings?.serviceAreaIds;
        this.branchIds = commonsService.parseArrayStateParam($stateParams.branchIds) || quickActiveFilter?.settings?.branchIds || viewFilterSettingsService.getBranchIds() || [];
        ;
        this.agentIds = $stateParams.agentIds || quickActiveFilter?.settings?.agentIds;
        this.status = $stateParams.status;
        this.agentSkills = $stateParams.agentSkills || quickActiveFilter?.settings?.agentSkills;


        if ($stateParams.from && $stateParams.to) {
          this.from = parseInt($stateParams.from)
          this.to = parseInt($stateParams.to);
        } else if (this.dateRangeTemplateType) {
          const dateRangeFilter = dateRangeTimeFiltersService.getDateRangeFilterByType(this.dateRangeTemplateType);
          this.from = dateRangeFilter.dateStart;
          this.to = dateRangeFilter.dateEnd;
        } else {
          this.from = undefined;
          this.to = undefined;
        }

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Routes"});
        triBreadcrumbsService.addCrumb({name: "Planning"});

      }
    })
    .state('planning-route', {
      parent: 'bringoz.site',
      url: '/planning/routes/:id',
      pageTrack: '/planning/route',
      controllerAs: 'vm',
      template: '<planning-route route="vm.route" meta-data="vm.metaData"></planning-route>',
      controller: function (triBreadcrumbsService, route, splitService: SplitService, site) {
        this.route = route;
        this.metaData = splitService.getRoutesMetadataSettings();

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: route.rid, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: "Routes", state: "planning-routes"});
        triBreadcrumbsService.addCrumb({name: "Planning"});

      },
      resolve: {
        route: function ($stateParams, $planningRoutes, site) {
          var query = {
            expandServices: false,
            expandTasks: true,
            expandTasksExt: true,
          }
          return $planningRoutes($stateParams.id).$get(query);
        }
      }
    })
    .state('planning-routes-loading', {
      parent: 'bringoz.site',
      controllerAs: 'vm',
      url: '/planning/routes-loading?:from&:to&:statuses&:branchIds&:resourceIds',
      template: '<planning-dispatch-routes-loading-view from="vm.from" to="vm.to" ' +
        'statuses="vm.statuses" branch-ids="vm.branchIds" resource-ids="vm.resourceIds"></planning-dispatch-routes-loading-view>',
      controller: function (triBreadcrumbsService, commonsService: CommonsService, $stateParams, site) {

        this.branchIds = $stateParams.branchIds ? commonsService.parseArrayStateParam($stateParams.branchIds) : [];
        this.statuses = $stateParams.statuses ? commonsService.parseArrayStateParam($stateParams.statuses) : [];
        this.resourceIds = $stateParams.resourceIds ? commonsService.parseArrayStateParam($stateParams.resourceIds) : [];

        if ($stateParams.from && $stateParams.to) {
          this.from = parseInt($stateParams.from);
          this.to = parseInt($stateParams.to);
        }

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "MODULES.loadingScreen"});
        triBreadcrumbsService.addCrumb({name: "Planning"});

      }
    })
    .state('planning-configuration', {
      parent: 'bringoz.site',
      url: '/planning/configuration',
      template: '<planning-configuration configuration="configuration"></planning-configuration>',
      controller: function ($scope, triBreadcrumbsService, configuration, site) {

        $scope.configuration = configuration;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Planning Settings"});
        triBreadcrumbsService.addCrumb({name: "Planning"});

      },
      resolve: {
        configuration: function (deliveriesRequestsService, site) {
          return deliveriesRequestsService.getAnalysisConfiguration();
        }
      }
    })

}
